var E = require('./index.js');
module.exports = new E();



//////////////////
// WEBPACK FOOTER
// /Users/adveris/Sites/anjac/web/app/themes/bulb/node_modules/tiny-emitter/instance.js
// module id = 3
// module chunks = 0